import { styled } from '@mui/material/styles';
import { Button, useTheme } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Box, Typography, Divider, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { orderTypesColor } from '../../../../Statics/index';
import {
    getorderViewIdSelectedR,
    openVieweModalR,
} from "../../../../../../../General/Store/GeneralSlice";
import { useSelector, useDispatch } from "react-redux";




const MotionBox = motion(Box);

const CustomTooltip = styled(({ className, ...props }: any) => (

    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.mode === 'dark'
            ? '#1f2937'
            : '#212121',
        color: '#fff',
        maxWidth: 260,
        borderRadius: 10,
        padding: 10,
        boxShadow: 4
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#1f2937',
    },
}));

// انیمیشن کانتینر
const containerVariants = {
    hidden: {
        opacity: 0,
        scale: 0.95,
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            staggerChildren: 0.12,
            delayChildren: 0.05,
        },
    },
};

// انیمیشن هر آیتم
const itemVariants = {
    hidden: {
        opacity: 0,
        y: 8,
    },
    visible: {
        opacity: 1,
        y: 0,
    },
};
const gridTemplate = '70px 60px 90px';


export default function TaskDetails({ item = {}, hasMainPrice = false, changeModuleMode = () => { }, ...rest }) {
    let { orderNumber, orderType, orderName, string_OrderType, customerName, string_StartTime, string_EndTime, duration, orderId } = item
    const dispatch = useDispatch();


    const initialViewOrder = () => {
        changeModuleMode((prev) => ({ ...prev, modal: true, mode: 'view' }));
        dispatch(openVieweModalR());
        console.log(item, 'itemmmmmmmmmmmmmmm')
        dispatch(getorderViewIdSelectedR({ ...item, 'id': item?.orderId }));
        //   setDyModal={setOrderOnlineState}

    }

    const itemVariants = {
        hidden: {
            opacity: 0,
            y: 15,
            scale: 0.9,
            filter: "blur(4px)"
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 24
            }
        },
    };

    return (
        <CustomTooltip
            arrow
            placement="top"
            title={
                <MotionBox
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >

                    <MotionBox variants={itemVariants}>
                        <Typography variant={'body1'} className={'font-num'} textAlign="center">
                            {orderNumber}
                        </Typography>
                    </MotionBox>

                    {/* خط جداکننده با انیمیشن پهنا */}
                    <MotionBox variants={itemVariants} sx={{ width: '100%', py: 0.5 }}>
                        <Divider sx={{ bgcolor: item?.colorCode, height: 2, borderRadius: 1 }} />
                    </MotionBox>

                    {/* نام سفارش */}
                    <MotionBox variants={itemVariants}>
                        <Typography variant={'caption'} className={'font-num'} sx={{ mb: 1, display: 'block', textAlign: 'center', fontWeight: 'bold' }}>
                            {orderName}
                        </Typography>
                    </MotionBox>

                    {/* ردیف‌های دیتا - هر ردیف را در یک MotionBox بگذار تا یکی‌یکی ظاهر شوند */}
                    {[
                        { label: 'نوع سفارش', value: string_OrderType, bg: item?.colorCode },
                        { label: 'نام مشتری', value: customerName },
                        { label: 'ساعت شروع', value: string_StartTime },
                        { label: 'ساعت پایان', value: string_EndTime },
                        { label: 'مدت زمان', value: duration },
                    ].map((row, index) => (
                        <MotionBox
                            key={index}
                            variants={itemVariants}
                            sx={{ display: 'flex', justifyContent: "space-between", width: '100%', alignItems: 'center', mb: 0.5, gap: 2 }}
                        >
                            <Typography variant="caption" className="font-num" sx={{ opacity: 0.8 }}>
                                {row.label}
                            </Typography>
                            <Typography
                                className="font-num"
                                sx={{
                                    bgcolor: row.bg || 'transparent',
                                    minWidth: 60,
                                    borderRadius: 1.5,
                                    p: 0.4,
                                    textAlign: 'center',
                                    fontSize: '0.7rem',
                                    border: row.bg ? 'none' : '1px solid rgba(255,255,255,0.1)'
                                }}
                            >
                                {row.value}
                            </Typography>
                        </MotionBox>
                    ))}

                    <MotionBox variants={itemVariants} sx={{ width: '100%', py: 0.5 }}>
                        <Divider sx={{ bgcolor: item?.colorCode }} />
                    </MotionBox>

                    {/* دکمه مشاهده */}
                    <MotionBox variants={itemVariants} sx={{ display: 'flex', justifyContent: "space-between", width: '100%', alignItems: 'center' }}>
                        <Typography variant="caption">مشاهده سفارش</Typography>
                        <IconButton
                            onClick={() => initialViewOrder()}
                            size="small"
                            sx={{ color: '#fff', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                        >
                            <i className="icon-Eye" style={{ fontSize: "16px" }}></i>
                        </IconButton>
                    </MotionBox>
                </MotionBox>





            }
        >
            <Box
                className="font-num"
                size="small"
                variant="outlined"
                endIcon={<MonetizationOnIcon fontSize="small" />}
                {...rest}
                onClick={() => initialViewOrder()}
            >

            </Box>



        </CustomTooltip>
    );
}
